import { useEffect } from 'react';
// Types
import type { CaptionProps } from 'react-day-picker';
import { useNavigation } from 'react-day-picker';

import { useAtomValue } from 'jotai';

// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import { Navigation } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption/Navigation';
// Components
import { SelectMonth } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption/SelectMonth';
import { SelectYear } from '@/components/base/Datepicker/DatepickerComponent/components/DatepickerCalendar/components/Caption/SelectYear';

export function Caption({ displayMonth }: CaptionProps) {
    const { goToMonth } = useNavigation();
    const datepicker = useAtomValue(datepickerAtom);

    useEffect(() => {
        // Redirect to the current month of the date selected
        const dateToEvaluate = datepicker.mode === 'range' ? datepicker.date?.to : datepicker.date;

        if (dateToEvaluate) {
            goToMonth(dateToEvaluate);
        }
    }, [datepicker.date]);

    return (
        <div className="mb-4 flex items-center justify-between px-3">
            <div className="flex items-center gap-2">
                <SelectMonth displayMonth={displayMonth} />
                <SelectYear displayMonth={displayMonth} />
            </div>
            <Navigation />
        </div>
    );
}
